import React from "react";
import { Typography } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";

const { Text } = Typography;

/**
 * Sectores de trabajo de una aseadora, SOLO LECTURA (round 2026-10-28).
 *
 * Pedido del dueño: «las aseadoras, en su perfil, no deben poder elegir sus sectores; es solo
 * admin o superadmin quien se los asigna». Los sectores deciden qué aseos abiertos ve y puede
 * tomar, así que dejarlos editables era elegir su propio trabajo. Acá se muestran como
 * etiquetas, sin ningún control editable; la administración los asigna desde `/aseadores`.
 * El backend ignora el campo si lo manda alguien que no es admin (`updateCleaner`), así que
 * esto no es solo cosmética.
 */
const SectoresSoloLectura: React.FC<{ sectores?: string[] | null }> = ({ sectores }) => {
  const lista = Array.isArray(sectores) ? sectores.filter(Boolean) : [];
  return (
    <div className="form-full perfil-sectores" data-testid="perfil-sectores">
      <div className="ant-form-item-label" style={{ textAlign: "left" }}>
        <label>Sectores de trabajo</label>
      </div>
      {lista.length > 0 ? (
        <div data-testid="perfil-sectores-lista">
          {lista.map((s) => (
            <span key={s} className="sector-tag" data-testid="perfil-sector-tag">
              <EnvironmentOutlined />
              {s}
            </span>
          ))}
        </div>
      ) : (
        <Text type="secondary" data-testid="perfil-sectores-vacio">
          Todavía no tienes sectores asignados.
        </Text>
      )}
      <div style={{ marginTop: 6 }}>
        <Text type="secondary" data-testid="perfil-sectores-nota">
          Tus sectores los asigna la administración.
        </Text>
      </div>
    </div>
  );
};

export default SectoresSoloLectura;
